import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractWS } from './abstractService';
import { Configuration } from '../../config/environment';
import { DefinoInputRentenTool } from '../../components/teaser/teaser.model';

@Injectable()
export class RestWS extends AbstractWS {
	path: string = '';

	constructor(http: HttpClient) {

		super(http);
		this.path = Configuration.url + Configuration.apiGen;
	}

	public getLanguages(lang: string) {
		return this.makeGetRequest(this.path + "appLabels/" + lang, null).then(data => {
			return data ? Promise.resolve(data) : Promise.reject(data);
		}).catch(err => {
			return Promise.reject(err);
		});
	}

	public getSalesOrg() {
		return this.makeGetRequest(this.path + "readAppPartner", null).then(data => {
			return Promise.resolve(data);
		}).catch(err => {
			return Promise.reject(err);
		});
	}

	public appCustomizations() {
		return this.makeGetRequest(this.path + "appCustomizations", null).then(data => {
			return Promise.resolve(data);
		}).catch(err => {
			return Promise.reject(err);
		});
	}

	public getInputByISalesData(data: string): Promise<DefinoInputRentenTool> {
		return this.makeGetRequest(this.path + "getInputByISalesData/" + data, null).then((data) => {
			return Promise.resolve(data);
		}).catch(err => {
			return Promise.reject(err);
		});
	}
}

export class ParamRequest {
	key: string;
	value: string;

	constructor(k: string, v: string) {
		this.key = k;
		this.value = v;
	}
}



// WEBPACK FOOTER //
// ./src/app/services/restService.ts